
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import apiUrl from "../src/environment/Api";
import axios from "axios";
import "./App.css";
import Sidebar from "./components/sidebar/Sidebar";
import Sidebarstaff from "./components/staffadmin/sidebar/Sidebarstaff";
import Navbar from "./components/Navbar";
import Navbarstaff from "./components/staffadmin/sidebar/Navbarstaff";
import Dashboard from "./components/pages/Dashboard";
import Role from "./components/pages/Role";
import Addrole from "./components/pages/Addrole";
import User from "./components/pages/User";
import Course from "./components/pages/Course";
import Student from "./components/pages/Student";
import Studyingstudents from "./components/pages/Studyingstudent";
import Completed from "./components/pages/Completed";

import Staff from "./components/pages/Staff";


import StaffInfo from "./components/pages/StaffInfo";
import Addstaff from "./components/pages/Addstaff";
import Updatestaff from "./components/pages/Updatestaff";
import Attendance from "./components/pages/Attendance";
import Assettype from "./components/pages/Assettype";
import Assetlist from "./components/pages/Assetlist";
import Expensetype from "./components/pages/Expensetype";
import Expenselist from "./components/pages/Expenselist";
import Incometype from "./components/pages/Incometype";
import Incomelist from "./components/pages/Incomelist";
import Designation from "./components/pages/Designation";
import Login from "./components/login/Login";
import Invoice from "./components/pages/Invoice";
import Leave from "./components/pages/Leave";

// Sraff admin

import Task from "././components/staffadmin/pages/Task";
import Stafflogin from "./components/staffadmin/stafflogin/Stafflogin";
import Profile from "./components/staffadmin/pages/Profile";
import Attendancestaff from "./components/staffadmin/pages/Attendancestaff";
import Leavestaff from "./components/staffadmin/pages/Leavestaff";

import Addinvoice from "./components/pages/Addinvoice";
import Print from "./components/pages/Print";
import Footer from "./components/footer/Footer";
import ProtectedRoute from "./components/pages/Helper";
import Editrole from "./components/pages/Editrole";
import Branch from "./components/pages/Branch";
import Addstudent from "./components/pages/Addstudent";
import Updatestudents from "./components/pages/Updatestudents";
import Updateinvoice from "./components/pages/Updateinvoice";
import StudentInfo from "./components/pages/StudentInfo";
import Followups from "./components/pages/Followups";
import Walkin from "./components/pages/Walkin";
import Sourcetype from "./components/pages/Sourcetype";

import Studentdairy from "./components/pages/Studentdairy";
import DailyReport from "./components/pages/DailyReport";
import AttendanceReport from "./components/pages/AttendanceReport";
import EnquiryReport from "./components/pages/EnquiryReport";
import Leadhistroy from "./components/pages/Leadhistroy";
import Registration from "./components/pages/Registration";
import RegistrationUpdate from "./components/pages/RegistrationUpdate";
import Enquiry from "./components/pages/Enquiry";
import Funnel from "./components/pages/Funnel";
import CourseInfo from "./components/pages/CourseInfo";
import NewPromotions from "./components/pages/NewPromotions";
import ExpenseReport from "./components/pages/ExpenseReport";
import StudentReport from "./components/pages/StudentReport";
import IncomeReport from "./components/pages/IncomeReport";
import StaffReport from "./components/pages/StaffReport";
import CoursePreview from "./components/pages/CoursePreview";
import UpdateRole from "./components/pages/UpdateRole";
import Salary from "./components/pages/Salary";
import Job from "./components/pages/Job";
import JobMemeberInfo from "./components/pages/JobMemberInfo";
import Category from "./components/pages/Category";
import Staff_payslip from "./components/pages/Staff_payslip"

import Jobportal from "./components/pages/Jobportal";
import JobDetails from "./components/pages/JobDetails";
import JobMemberDetail from "./components/pages/JobMemberDetail";



import Feeduefollowups from "./components/pages/Feeduefollowups";

import Notfounded from "./components/pages/Notfounded";
import Enquirypurpose from "./components/pages/Enquirypurpose";

import Pay_type from "./components/pages/Pay_type";
import VendarDetails from "./components/pages/VendarDetails";
import CourseImagePreview from "./components/pages/CourseImagePreview";

import InvoiceReport from "./components/pages/InvoiceReport";
import Studentinvoice from "./components/pages/Studentinvoice";



import HolidayLeave from "./components/pages/HolidayLeave";
import Calender from "./components/pages/Calender";
import Attendanceoverall from "./components/pages/Attendanceoverall";
import Expense_details from "./components/pages/Officeexpense";
import Officeexpense from "./components/pages/Officeexpense";
import Marketing_leads from "./components/pages/Marketing_leads";
import Charges from "./components/pages/Charges";
import Contact_leads from "./components/pages/Contact_leads";
import Travel_Allowance from "./components/pages/Travel_Allowance";
import SinglePageView from "./components/pages/SinglePageView";
import Event from './components/pages/Event';
import Leo from "./components/pages/Leo";
import Salary_generate from "./components/pages/Salary_generate";
import EventTable from "./components/pages/EventTable";
import Dailytask from "./components/pages/Dailytask";
import Recruiting_partner from "./components/pages/Recruiting_partner";
import Intership from "./components/pages/Intership";
import Student_internship from "./components/pages/Student_internship";
import Enquiry_Fileupload from "./components/pages/Enquiry_Fileupload";
import Intern_fileupload from "./components/pages/Intern_fileupload";
import Studentdairy_fileupload from "./components/pages/Studentdairy_fileupload";
import Studentdownload from "./components/pages/Studentdownload";
import Invoice_email from "./components/pages/Invoice_email";
import Addjobportal from "./components/pages/Addjobportal";
import Updatejobportal from "./components/pages/Updatejobportal";
import Duminvoice from "./components/pages/Duminvoice";

// import Attendance_fileupload from "./components/pages/Attendance_fileupload";




const App = () => {



  const [lastActivityTime, setLastActivityTime] = useState(Date.now());
  const inactivityLimit = 50 * 60 * 1000; // 10 minutes in milliseconds


  // Function to log out the user
  // const logoutUser = () => {
  //   // Remove any session or authentication token
  //   localStorage.removeItem("userToken");
  //   sessionStorage.removeItem("userToken");
  //   window.location.href = "/";  // Redirect to the login page
  // };

  const logoutUser = async () => {
    try {
      const last_logout_time = new Date().toLocaleString();

      const username = localStorage.getItem("username");

      await axios.post(apiUrl + '/logoutadmin', { username, last_logout_time });

      // Clear session data
      localStorage.removeItem("token");
      sessionStorage.removeItem("userToken");

      // Redirect to login
      window.location.href = "/";
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };


  // Reset inactivity timer on user interaction
  const resetInactivityTimer = () => {
    setLastActivityTime(Date.now());
  };

  useEffect(() => {
    // Check inactivity every minute
    const interval = setInterval(() => {
      if (Date.now() - lastActivityTime >= inactivityLimit) {
        logoutUser();  // Log out the user if inactive for 10 minutes
      }
    }, 60000);  // Check every 1 minute

    // Add event listeners to detect user interaction
    const events = ["mousemove", "keydown", "click"];
    events.forEach(event => window.addEventListener(event, resetInactivityTimer));

    // Cleanup event listeners and interval on component unmount
    return () => {
      clearInterval(interval);  // Clear the inactivity timer interval
      events.forEach(event => window.removeEventListener(event, resetInactivityTimer));
    };
  }, [lastActivityTime]);



  return (
    <Router>
      <Routes>
        {/* user admin */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Dashboard /> <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/leo"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Leo /> <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/role"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Role /> <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/addrole"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Addrole />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />


        <Route
          path="*"
          element={
            <ProtectedRoute>
              <Notfounded />
            </ProtectedRoute>
          }
        />

        <Route
          path="/updaterole"
          element={
            <ProtectedRoute>
              <Sidebar>
                <UpdateRole />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/user"
          element={
            <ProtectedRoute>
              <Sidebar>
                <User /> <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/branch"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Branch />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/course"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Course />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/category"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Category />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/courseinfo/:id/:course_id"
          element={
            <ProtectedRoute>
              <Sidebar>
                <CourseInfo />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/coursepreview/:id/:course_id"
          element={
            <ProtectedRoute>
              <Sidebar>
                <CoursePreview />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/newpromotions"
          element={
            <ProtectedRoute>
              <Sidebar>
                <NewPromotions />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/marketing"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Marketing_leads />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />

        <Route
          path="/student"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Student />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />




        <Route
          path="/fileupload"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Enquiry_Fileupload />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />

        <Route
          path="/eventTable"
          element={
            <ProtectedRoute>
              <Sidebar>
                <EventTable />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/salary_generate"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Salary_generate />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Enquiry"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Enquiry />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/studyingstudents"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Studyingstudents />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/completed"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Completed />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />

        <Route
          path="/singlepageview/:id"
          element={
            <ProtectedRoute>
              <Sidebar>
                <SinglePageView />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />

        <Route
          path="/courseimagepreview/:id/:course_id"
          element={
            <ProtectedRoute>
              <Sidebar>
                <CourseImagePreview />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/addstudent"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Addstudent />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/updatestudents/:id"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Updatestudents /> <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/staff"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Staff />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />


        <Route
          path="/payslip"
          element={
            <ProtectedRoute>
              <Staff_payslip />
            </ProtectedRoute>
          }
        />


        <Route
          path="/event"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Event />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />

        <Route
          path="/staffinfo/:id"
          element={
            <ProtectedRoute>
              <Sidebar>
                <StaffInfo />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/studentinvoice/:id"
          element={
            <ProtectedRoute>

              <Studentinvoice />


            </ProtectedRoute>
          }
        />


        <Route
          path="/Studentdownload/:id"
          element={
            <ProtectedRoute>

              <Studentinvoice  />


            </ProtectedRoute>
          }
        />




        <Route
          path="/Walkin/:url_branch_name"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Walkin />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Followups/:url_branch_name"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Followups />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/addstaff"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Addstaff />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Studentdairy"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Studentdairy />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/studentdairy_upload"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Studentdairy_fileupload />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />

        {/* <Route
          path="/Attendance_fileupload"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Attendance_fileupload />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        /> */}

        <Route
          path="/dailytask"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Dailytask />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />


        <Route
          path="/Recruiting"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Recruiting_partner />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Studentinfo/:id"
          element={
            <ProtectedRoute>
              <Sidebar>
                <StudentInfo />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Followups"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Followups />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Funnel"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Funnel />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Walkin"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Walkin />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Sourcetype"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Sourcetype />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Enquirypurpose"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Enquirypurpose />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/paytype"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Pay_type />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />


        <Route
          path="/databasefile"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Intern_fileupload />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Studentdatabase"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Intership />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />

        <Route
          path="/student_intern"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Student_internship />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Calender/:empid"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Calender />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/job"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Job />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/jobportal"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Jobportal />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Addjobportal"
          element={
            <ProtectedRoute>
              <Sidebar>
                {" "}
                <Addjobportal />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Updatejobportal/:id"
          element={
            <ProtectedRoute>
              <Sidebar>
                {" "}
                <Updatejobportal />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/JobDetails/:id"
          element={
            <ProtectedRoute>
              <Sidebar>
                <JobDetails />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/jobMemberinfo"
          element={
            <ProtectedRoute>
              <Sidebar>
                <JobMemeberInfo />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/jobMemberDetail/:id"
          element={
            <ProtectedRoute>
              <Sidebar>
                <JobMemberDetail />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Registration/:id"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Registration />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Registrationupdate/:id"
          element={
            <ProtectedRoute>
              <Sidebar>
                <RegistrationUpdate />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/updatestaff/:id"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Updatestaff />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Leadhistroy/:id"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Leadhistroy />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/attendance"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Attendance />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />

        <Route
          path="/attendanceoverall"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Attendanceoverall />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/assettype"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Assettype />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/assetlist"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Assetlist />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/expensetype"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Expensetype />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/expenselist"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Expenselist />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/vendarDetails"
          element={
            <ProtectedRoute>
              <Sidebar>
                <VendarDetails />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Officeexpense"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Officeexpense />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/incometype"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Incometype />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/incomelist"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Incomelist />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />

        <Route
          path="/holiday"
          element={
            <ProtectedRoute>
              <Sidebar>
                <HolidayLeave />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />

        <Route
          path="/charge"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Charges />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />


        <Route
          path="/contact"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Contact_leads />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/travel_allowance"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Travel_Allowance />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />


        <Route
          path="/designation"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Designation />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoice"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Invoice />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dailyreport"
          element={
            <ProtectedRoute>
              <Sidebar>
                {" "}
                <DailyReport />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/AttendanceReport"
          element={
            <ProtectedRoute>
              <Sidebar>
                {" "}
                <AttendanceReport /> <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />

        <Route
          path="/invoiceReport"
          element={
            <ProtectedRoute>
              <Sidebar>
                {" "}
                <InvoiceReport /> <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ExpenseReport"
          element={
            <ProtectedRoute>
              <Sidebar>
                {" "}
                <ExpenseReport /> <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/staffreport"
          element={
            <ProtectedRoute>
              <Sidebar>
                {" "}
                <StaffReport /> <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/StudentReport"
          element={
            <ProtectedRoute>
              <Sidebar>
                {" "}
                <StudentReport /> <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/incomereport"
          element={
            <ProtectedRoute>
              <Sidebar>
                {" "}
                <IncomeReport />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Enquiryreport"
          element={
            <ProtectedRoute>
              <Sidebar>
                {" "}
                <EnquiryReport />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/leave"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Leave />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/salary"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Salary />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />

        <Route
          path="/invoice_email"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Invoice_email />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />


        <Route
          path="/Addinvoice"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Addinvoice />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Duminvoice/:roll_no"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Duminvoice />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Addinvoice/:roll_no"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Addinvoice />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route
          path="/updateinvoice/:id"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Updateinvoice />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />
        <Route path="/Print/:id" element={<Print />} />
        {/* <Route path="/admin" element={<Login />} /> */}
        <Route path="/" element={<Login />} />
        <Route
          path="/Editrole/:id"
          element={
            <ProtectedRoute>
              <Sidebar>
                <Editrole />
                <Footer />
              </Sidebar>
            </ProtectedRoute>
          }
        />

        {/* staffadmin */}
        <Route
          path="/leavestaff"
          element={
            <ProtectedRoute>
              {" "}
              <Sidebarstaff>
                <Leavestaff />
                <Footer />
              </Sidebarstaff>
            </ProtectedRoute>
          }
        />
        <Route
          path="/task"
          element={
            <ProtectedRoute>
              <Sidebarstaff>
                <Task />
              </Sidebarstaff>
              <Footer />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile/:id"
          element={
            <ProtectedRoute>
              {" "}
              <Sidebarstaff>
                <Profile />
                <Footer />
              </Sidebarstaff>
            </ProtectedRoute>
          }
        />
        <Route
          path="/attendancestaff"
          element={
            <ProtectedRoute>
              {" "}
              <Sidebarstaff>
                <Attendancestaff />
                <Footer />
              </Sidebarstaff>
            </ProtectedRoute>
          }
        />
        <Route
          path="/feeduefollowups"
          element={
            <ProtectedRoute>
              <Sidebarstaff>
                <Feeduefollowups />
              </Sidebarstaff>
              <Footer />
            </ProtectedRoute>
          }
        />
        {/* <Route path="/" element={<Stafflogin />} /> */}
        <Route path="/stafflogin" element={<Stafflogin />} />
      </Routes>
    </Router>
  );
};

export default App;
